<template>
    <div>Loading</div>
</template>

<script>
export default {
  name: 'loading'
};
</script>

<style scoped>

</style>
